// import React, { useState } from "react";

import { CallPopUpAgentActions } from "../../../../store/slices/voice_call_slice/call_popup_agent";
import { CallService } from "../../../../services/call_service";

import { Input, Select } from "antd";

import _ from "lodash";
// import callChatService from "../../../../base/service/chatService";
// import { callSDK } from "unifiedring-sdk";
// import flag from "../../../../styles/images/flag.png";
// import { getContactDetailsWhilegettingCall } from "../../../../store/api/helperspi/contactListapiService";
// import { getUser } from "../../../../constants/base/utils";
import styles from "./dialpadnumber.module.scss";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
// import { v4 as uuidv4 } from "uuid";

export default function DialpadDtmf() {

  const contactList: any = useSelector((state: any) => state.contactListForAgent);
  const { isQueueList, AllQueueList, filterQueueList } = contactList;
  const dialPadDetails: any = useSelector((state: any) => state.callPopUpDetails);
  let { dialedNumber, queueDetails, queueName, isCalling, callDetails, incomingCallDetail } = dialPadDetails;
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const { sendDTMF } = CallService(dispatch, navigate);
  const backSpace = () => {
    if (dialedNumber.length !== 0) {

    }
  };

  document.addEventListener("longpress", function (e) { });



  const onKeyPress = (number: any) => {
    if (number !== "") {

      sendDTMF(incomingCallDetail, number)
    }
  };

  let timer: any = null;
  let plus = 0;

  const onmousedownfunc = (e: any) => {
    if (e.button === 0) {
      const longpressfunc = () => {
        setTimeout(() => {
          plus = 1;
        }, 600);
      };
      timer = longpressfunc();
    }
  };

  const onKeyUpPressed = () => {
    clearTimeout(timer);
    if (plus === 1) {
      dispatch(CallPopUpAgentActions.setDialPadOnKeyPressUP("+"));
    } else {
      dispatch(CallPopUpAgentActions.setDialPadOnKeyPressUP("0"));
    }
    plus = 0;
  };






  return (
    <div>
      <div className={`dialpadinput ${styles.dialtop}`}>
        <Input className={styles.dtmf} onChange={(e: any) => onKeyPress(e.target.value)} ></Input>
      </div>
      <div className={`scroller ${styles.dialscreens}`}>
        <div className={styles.chatDialPadInner}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold}`} onClick={() => onKeyPress("1")}>
            <span className="">1</span>
            <div className={styles.tooltips}></div>
          </div>
        </div>
        <div className={styles.chatDialPadInner}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold}`} onClick={() => onKeyPress("2")}>
            <span className="">2</span>
            <div className={styles.tooltips}>ABC</div>
          </div>
        </div>
        <div className={styles.chatDialPadInner}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold}`} onClick={() => onKeyPress("3")}>
            <span className="">3</span>
            <div className={styles.tooltips}>DEF</div>
          </div>
        </div>
        <div className={styles.chatDialPadInner}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold}`} onClick={() => onKeyPress("4")}>
            <span className="">4</span>
            <div className={styles.tooltips}>GHI</div>
          </div>
        </div>
        <div className={styles.chatDialPadInner}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold}`} onClick={() => onKeyPress("5")}>
            <span className="">5</span>
            <div className={styles.tooltips}>JKL</div>
          </div>
        </div>
        <div className={styles.chatDialPadInner}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold}`} onClick={() => onKeyPress("6")}>
            <span className="">6</span>
            <div className={styles.tooltips}>MNO</div>
          </div>
        </div>
        <div className={styles.chatDialPadInner}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold}`} onClick={() => onKeyPress("7")}>
            <span className="">7</span>
            <div className={styles.tooltips}>PQRS</div>
          </div>
        </div>
        <div className={styles.chatDialPadInner}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold}`} onClick={() => onKeyPress("8")}>
            <span className="">8</span>
            <div className={styles.tooltips}>TUV</div>
          </div>
        </div>
        <div className={styles.chatDialPadInner}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold}`} onClick={() => onKeyPress("9")}>
            <span className="">9</span>
            <div className={styles.tooltips}>WXYZ</div>
          </div>
        </div>
        <div className={styles.chatDialPadInner}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold}`} onClick={() => onKeyPress("*")}>
            <span className={styles.starNumber}>*</span>
            <div className={styles.tooltipsIcn}>,</div>
          </div>
        </div>
        <div className={styles.chatDialPadInner} onMouseDown={onmousedownfunc} onClick={onKeyUpPressed}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold}`}>
            <span className="">0</span>
            <div className={styles.tooltipsIcn}>+</div>
          </div>
        </div>
        <div className={styles.chatDialPadInner}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold}`} onClick={() => onKeyPress("#")}>
            <span className="">#</span>
          </div>
        </div>

        {isQueueList && callDetails?.length === 0 && (
          <div className={`${styles.chatDialCall} ${styles.chatdialnew}`}>
            {/* <WtButton className="makeCall" name="Make a call" onClick={makeCall} /> */}
            <Select 
              getPopupContainer={(trigger: { parentNode: any }) => trigger.parentNode}
              value={queueDetails.value}
              onChange={(value: any, key: any) => {
                dispatch(CallPopUpAgentActions.setQueueName(key));
              }}
              placeholder="Select queue"
              className="antSelect selectcloseicon"
              popupClassName="antSelectPopover tickrightremove "
              showArrow={true}
              optionFilterProp="children"
              suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                    <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676"/>
                  </svg>}
              filterOption={(input, option: any) => {
                return option.value?.toLowerCase().indexOf(input?.toLowerCase()) >= 0;
              }}
              options={filterQueueList.map((item: any) => ({
                key: item.qid,
                value: item.name,
              }))}
            ></Select>
          </div>
        )}

        {/* <div className={styles.chatDialCall}>
          <WtButton disabled={dialedNumber.length === 0 ? true : false} className="makeCall" name="Make a call" onClick={getContactDetail} />
        </div> */}
      </div>
    </div>
  );
}
